import {Component, Inject, OnDestroy, OnInit, ViewChild, AfterViewChecked, ElementRef} from '@angular/core';
import {emtrConstant} from '../../../constants/emtrConstants';
import {InstrumentGroupFormDataService} from '../instrument-group-form-data/instrument-group-form-data.service';
import {ManageEmpGrpService, SharedConstant, SharedService, CustomSortService, InstrumentGroupService , EmtrPagination, EmtrPaginationValues} from '@ems/shared';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {Paginator} from 'primeng/paginator';
import {DefaultSecurityGridHeader} from '../../../models/search-security-modal.model';
import {filterSecurityGridHeader} from '../../../models/search-security-modal.model';
import {RuleService} from '../../../services/rule-service/rule.service';
import {finalize, Observable, Observer} from 'rxjs';
import {EmtrService} from '../../../emtr.service';
import { HttpResponse } from '@angular/common/http';
import {interval, switchMap, take, takeWhile, Subscription} from 'rxjs';
@Component({
  selector: 'tr-step3-review-and-save',
  templateUrl: './step3-review-and-save-instrument-group.component.html'
})
export class Step3ReviewAndSaveInstrumentGroupComponent implements OnInit,OnDestroy, AfterViewChecked {

  @ViewChild('confirmationMessage', { static: true }) confirmationMessage: any;
  @ViewChild('p') paginator: Paginator;
  forceSyncStatusSubscription: Subscription;
  pageObject: EmtrPagination = EmtrPaginationValues;
  securityTableHeader = DefaultSecurityGridHeader;
  filterSecurityTableHeader = filterSecurityGridHeader;
  getConstant = emtrConstant;
  getSharedConstant = SharedConstant;
  noOfRecords: any = 15;
  reviewInstGroupData: any;
  reviewInstrumentGrpForm: UntypedFormGroup;
  filterReviewInstrumentGrpForm: UntypedFormGroup;
  showGroupNameCharLimit: boolean;
  showGroupDescCharLimit: boolean;
  businessUnitData = [];
  showActionItems = true;
  revertDisable = true;
  selectedSecurities: any = [];
  addOrRemovedSecurities: any;
  message: string;
  cancelButton = true;
  errorMsg = [];
  confirmMessage: any;
  localObserver: any;
  unAssignedSsId = [];
  assignedSsId = [];
  toolTipMessage: any;
  groupNameExists = false;
  disableDownloadButton  = false;
  instGroupNameExistsErrMsg = '';
  downLoadNGOMSIG = false;
  showIGAssignPanel = false;
  ngOMSForceSync = false;
  forceSyncDisableBtn = false;
  toggle = false;
  filterClicked = false;
  isClickedClearBtn = false;
  isSortingChanged = false;

  multiSortMetaDup: any = [];
  multiSortMeta: any = [];
  defaultSortDataField = { field: 'updTs', order: -1 };
  sortClearButtonReset = false;
  getEmtrConstants = emtrConstant;
  paginationCount: any = 0;
  invalidCusip = false
  invalidSedol = false;
  invalidIsin =false;
  invalidName = false;
  invalidTickerSymbol = false;
  totalSecurities: any = 0;
  filtersApply: boolean;

  constructor(@Inject('commonConstants') public commonConstants, public fb: UntypedFormBuilder, private router: Router, public emtrService: EmtrService,
              private r: ActivatedRoute, public formDataService: InstrumentGroupFormDataService, public instrumentGrpService: InstrumentGroupService,
              public sharedService: SharedService, @Inject('entitlementConst') public entitlementConst, private manageEmpGrpService: ManageEmpGrpService, public ruleService: RuleService,
              public customSortService: CustomSortService, public el: ElementRef) {
    this.reviewInstGroupData = {...this.formDataService.getFormData()};
  }

  ngOnInit() {
    this.showActionItems = this.sharedService.checkEntitlements(this.entitlementConst.navUUID.emtrAccess.manageInstruments.uuid, '', '') && !this.instrumentGrpService.deletedIG;
    this.pageObject.pageNo =  0;
    this.pageObject.pageSize =  15;
    this.multiSortMeta = [{ ...this.defaultSortDataField }];
    this.totalSecurities = this.reviewInstGroupData.securityInfoList.length;
    this.customSortService.sortArr = [];
    this.sharedService.tableDropdownVal.next(this.pageObject.pageSize);
    this.filterReviewInstrumentGrpForm = this.fb.group({
      tickerSymbol: '',
      securityType: '',
      name: '',
      cusip: '',
      sedol: '',
      isin: ''
    });
    this.reviewInstrumentGrpForm = this.fb.group({
      groupName: '',
      description: '',
      businessUnit: ''
    });
    this.onChanges();
    this.populateData();
    if (this.reviewInstGroupData.mode === 'EDIT') {
    this.getFilterInstrumentGroupList();
    }
    if (!this.showActionItems) {
    this.reviewInstrumentGrpForm.get('groupName').disable();
    this.reviewInstrumentGrpForm.get('description').disable();
    }
    this.reviewInstrumentGrpForm.get('businessUnit').disable();
    this.confirmMessage = this.confirmationMessage.confirmMessage;
    this.confirmMessage.message = this.getConstant.rulesConstant.confirmationMessage.menuClickMsg;
    this.toolTipMessage = this.getConstant.ruleSteps.step4.descTooltip;
   if(this.reviewInstGroupData.mode === 'EDIT' && ((this.instrumentGrpService.deletedIG && this.reviewInstGroupData.ngOMSSecurityGroupsInfo) || !this.instrumentGrpService.deletedIG)){
    this.checkIGForEntitlements();
     this.reviewInstGroupData.ngOMSSecurityGroupsInfo?.groupId && this.reviewInstGroupData.ngOMSSecurityGroupsInfo?.lastSyncStatus.toUpperCase() !== this.getSharedConstant.ngOMS.inProgress ?
      this.disableDownloadButton = false : this.disableDownloadButton = true;

    if (!this.instrumentGrpService.deletedIG) {
      this.reviewInstGroupData.ngOMSSecurityGroupsInfo?.lastSyncStatus.toUpperCase() !== this.getSharedConstant.ngOMS.inProgress ?
        this.forceSyncDisableBtn = false : this.forceSyncDisableBtn = true;
    } else {
      this.reviewInstGroupData.ngOMSSecurityGroupsInfo?.groupId && this.reviewInstGroupData.ngOMSSecurityGroupsInfo?.lastSyncStatus.toUpperCase() !== this.getSharedConstant.ngOMS.inProgress ?
        this.forceSyncDisableBtn = false : this.forceSyncDisableBtn = true;
    }

    // make poller call if lastsync status is inprogress
    if (this.reviewInstGroupData.ngOMSSecurityGroupsInfo?.lastSyncStatus && this.reviewInstGroupData.ngOMSSecurityGroupsInfo?.lastSyncStatus.toUpperCase() === this.getSharedConstant.ngOMS.inProgress) {
       this.pollLastSyncStatusForceSync();
    } else if (!this.instrumentGrpService.deletedIG) {
        this.validateForceSyncDownloadBtns();
    }
  }
    //pushingvalues to securtityType dropdown

     this.getEmtrConstants.instrumentGroups.instrumentGrpStep3.securityTypeList
    .sort((a, b) => a.value.localeCompare(b.value))
    .map(item => item.value);
      setTimeout(() => {
         this.filterReviewInstrumentGrpForm.patchValue({securityType: this.getEmtrConstants.instrumentGroups.instrumentGrpStep3.securityTypeList});
      }, 10);
}

  ngAfterViewChecked(): void {
    const elementRef = this.el.nativeElement.querySelectorAll('.p-multiselect-label')[0];
    this.sharedService.setMultiSelectDefaultLabel(elementRef, this.filterReviewInstrumentGrpForm, 'securityType', this.getEmtrConstants.instrumentGroups.instrumentGrpStep3.securityTypeList.length);
  }
  ngomsEnablingOfButtonsAfterPolling() {
    // Check if groupId exists; if it does, enable the download button, otherwise disable it
    this.reviewInstGroupData.ngOMSSecurityGroupsInfo?.groupId ? this.disableDownloadButton = false : this.disableDownloadButton = true;

    // If the instrument group is active, always enable the force sync button
    if (!this.instrumentGrpService.deletedIG) {
      this.forceSyncDisableBtn = false;
    } else {
      // If the instrument group is soft-deleted, check if groupId exists; enable the force sync button if it does, otherwise disable it
      this.reviewInstGroupData.ngOMSSecurityGroupsInfo?.groupId ? this.forceSyncDisableBtn = false : this.forceSyncDisableBtn = true;
    }
}

 checkIGForEntitlements() {
    const buPolicy = this.sharedService.policy && this.sharedService.policy.data ? this.sharedService.policy.data.userPolicy : {};
    const entitlementList = buPolicy.buPolicy && buPolicy.buPolicy.length > 0 ? buPolicy.buPolicy : buPolicy.clientPolicy;
    let entitlementListArr;
    if (this.reviewInstGroupData && this.reviewInstGroupData.businessUnit) {
        if (buPolicy.buPolicy && buPolicy.buPolicy.length > 0) {
          buPolicy['businessUnit'] = this.reviewInstGroupData.businessUnit.value;
          entitlementListArr = entitlementList.filter(data => {
            return data.businessUnit === buPolicy.businessUnit;
          });
        } else {
          if (this.sharedService.policy.data?.clients.length > 0) {
            const clientId = this.sharedService.policy.data.clients.filter(client =>  client.businessUnit === 'RBS' );
            if (entitlementList && entitlementList.length > 0) {
              entitlementListArr = entitlementList.filter(data => {
                return data.clientId === clientId[0].clientId;
              });
            }
          }
        }
        if (entitlementListArr && entitlementListArr.length > 0) {
          for (const entitlement of entitlementListArr[0].entitlementList) {
            if (entitlement.uuid === this.entitlementConst.navUUID.ngOMS.securityGroupsSyncSummary.uuid) {
              this.showIGAssignPanel = true
            }
            if (entitlement.uuid === this.entitlementConst.navUUID.ngOMS.igSyncSummaryDownload.uuid) {
              this.downLoadNGOMSIG = true
            }
            if (entitlement.uuid === this.entitlementConst.navUUID.ngOMS.igSyncSummaryForce.uuid) {
              this.ngOMSForceSync = true
            }
          }
        }
    }
  }


  populateData() {
    /* To form addOrRemovedSecurities list to display removed and newly selected securities on UI with green and red highlight */
    this.setAssignedAndUnassignedSsid();
    this.businessUnitData.push(this.reviewInstGroupData.businessUnit);
    this.reviewInstrumentGrpForm.patchValue({
      groupName: this.reviewInstGroupData.name,
      description: this.reviewInstGroupData.description,
      businessUnit: this.reviewInstGroupData.businessUnit
    });
  }

  cancelInstGroup() {
    this.navigateTo(this.getConstant.instrumentGroups.instrumentGroupList.toLandingPage);
    this.confirmMessage.message = this.getConstant.rulesConstant.confirmationMessage.cancelBtnClickMsg;
  }

  get isStep1DetailsUnchanged(): boolean {
    return this.reviewInstrumentGrpForm.get('groupName')?.value?.trim() === this.reviewInstGroupData.currentEditedName?.trim()
      && this.reviewInstrumentGrpForm.get('description')?.value?.trim() === this.reviewInstGroupData.currentEditedDescription?.trim()
      && this.reviewInstrumentGrpForm.get('businessUnit')?.value?.value === this.reviewInstGroupData.currentEditedBusinessUnit;
  }

  exportInstrumentGroup() {
    this.sharedService.exportResource(
      this.getConstant.exportTypes.instrumentGroup,
      this.reviewInstGroupData.id,
      this.reviewInstGroupData.businessUnit.value,
      {
        onSuccess: (successMessage) => {
          this.ruleService.toastType.emit('info');
          this.ruleService.toastMsg.emit(successMessage);
        },
        onError: (errorMessage) => {
          this.ruleService.toastType.emit('error');
          this.ruleService.toastMsg.emit(errorMessage);
        }
      }
    );
  }

  goToPreviousStep(path) {
    if (this.reviewInstrumentGrpForm.dirty && !this.revertDisable) {
      this.confirmMessage.message = this.getConstant.rulesConstant.confirmationMessage.previousBtnClickMsg;
      new Observable<boolean>((observer) => {
        this.confirmationMessage.showConfirmMsg(this.confirmMessage, observer);
      }).subscribe((accept) => {
        if (accept) {
          this.errorMsg = [];
          this.emtrService.schErrorMsg.emit(this.errorMsg);
          this.emtrService.showSchError.emit(false);
          const formObj = {
            groupName: this.reviewInstrumentGrpForm.get('groupName').value.trim(),
            description: this.reviewInstrumentGrpForm.get('description').value,
            businessUnit: this.reviewInstrumentGrpForm.get('businessUnit').value
          };
          this.cancelButton = false;
          this.formDataService.setStep1(formObj, true);
          this.formDataService.setStep3('', false);
          this.navigateTo(path);
        }
      });
    } else {
      this.formDataService.setStep3('', false);
      this.navigateTo(path);
    }
  }


  revertChanges() {
    this.reviewInstrumentGrpForm.get('groupName').setValue(this.reviewInstGroupData.name);
    this.reviewInstrumentGrpForm.get('description').setValue(this.reviewInstGroupData.description);
    this.revertDisable = true;
  }
  editGroupNameAndDescription() {
    this.revertDisable = false;
  }
  receiveDataFromChild(e) {
    this.noOfRecords = parseInt(e, 10);
    this.selectedSecurities = [...this.selectedSecurities];
    this.addOrRemovedSecurities = [...this.addOrRemovedSecurities];
  }

  saveGroup() {
    this.cancelButton = false;
    this.saveInstGroup('save');
  }

  saveInstGroup(inputData) {
    const reviewDataCopy: any = {...this.reviewInstGroupData};
    reviewDataCopy.assignSsId = this.assignedSsId;
    reviewDataCopy.unAssignSsId = this.unAssignedSsId;
    delete reviewDataCopy.instrumentGrpAssignInfo;
    delete reviewDataCopy.employeeGroupAssignInfo;
    delete reviewDataCopy.securityInfoList;
    delete reviewDataCopy.previousSecurityInfoList;
    this.getFormValues();
    if (inputData) {
      reviewDataCopy.name = this.reviewInstrumentGrpForm.get('groupName').value.trim();
      reviewDataCopy.description = this.reviewInstrumentGrpForm.get('description').value;
      reviewDataCopy.businessUnit = this.reviewInstrumentGrpForm.get('businessUnit').value.name;
    }
    this.checkWhetherInstGroupNameExists(reviewDataCopy);
  }

  /* To set value to assigned, unassigned and addOrRemovedSecurities */
  setAssignedAndUnassignedSsid() {
    this.addOrRemovedSecurities = [];
    this.assignedSsId = [];
    this.unAssignedSsId = [];
    const securitiesList: any = [...this.reviewInstGroupData.securityInfoList];
    const localFormDataObj: any = {...this.reviewInstGroupData};
    if (securitiesList && securitiesList.length > 0) {
      securitiesList.forEach(security => {
        /* Loop through selected security array and compare with the security that was already assigned to IG to create assignedSsId */
        if (localFormDataObj.previousSecurityInfoList.map(y => y.ssid).indexOf(security.ssid) === -1) {
          security.selectedSec = true;
          this.addOrRemovedSecurities.push(security);
          this.assignedSsId.push(security.ssid);
        }
      });
    }
    localFormDataObj.previousSecurityInfoList.forEach(securities => {
      /* Loop security that was already assigned to IG and compare with securities selected to filter the removed securities */
      const unAssignedVal = securitiesList.map(y => y.ssid).indexOf(securities.ssid) === -1;
      if (unAssignedVal) {
        this.addOrRemovedSecurities.push(securities);
        this.unAssignedSsId.push(securities.ssid);
      }
    });
  }

  getFormValues() {
    this.reviewInstGroupData.name = this.reviewInstrumentGrpForm.get('groupName').value.trim();
    this.reviewInstGroupData.description = this.reviewInstrumentGrpForm.get('description').value;
  }

  navigateTo(path) {
    this.router.navigate([path], {relativeTo: this.r});
  }

  saveInstGroupData(reviewDataCopy) {
    if (!reviewDataCopy.id) {
      delete reviewDataCopy.ngOMSSecurityGroupsInfo;
    }
    this.instrumentGrpService.saveInstrumentGroup(reviewDataCopy).subscribe(res => {
      this.message = '<strong>' + this.reviewInstrumentGrpForm.get('groupName').value.trim() + ' - ' + '</strong>' + this.getConstant.instrumentGroups.instrumentGroupList.instrumentGrpSaveMsg;
      this.manageEmpGrpService.sendMessage(this.message, '');
      this.navigateTo(this.getConstant.instrumentGroups.instrumentGroupList.toLandingPage);
    });
  }

  downloadNgomsRuleAndForceSyncUp(event) {
    const formData = {
      groupId: this.reviewInstGroupData.id,
      bu: this.reviewInstGroupData.businessUnit.value
    }
    this.disableDownloadButton = this.forceSyncDisableBtn = true;
    this.sharedService.ngOMSforceSyncDownloadFile(formData, event).subscribe({
      next: (response: HttpResponse<Blob>) => {
        if (event === 'download') {
          this.sharedService.callNgOmsDownloadFile(response);
        } else {
          this.ruleService.toastType.emit('info');
          this.ruleService.toastMsg.emit(this.getSharedConstant.ngOMS.infoMsgGroup);
          this.pollLastSyncStatusForceSync();
        }
      },
      error: () => {
        this.validateForceSyncDownloadBtns();
      },
      complete: () => {
        if (event === 'download') {
          this.validateForceSyncDownloadBtns();
        }
      }
    })
  }


  pollLastSyncStatusForceSync() {
    const reqCorrelationId = this.reviewInstGroupData.ngOMSSecurityGroupsInfo?.reqCorrelationId;
    let pollerCallCount = 0;
    this.forceSyncStatusSubscription = interval(5000).pipe(

      switchMap(() => {
        pollerCallCount++; // Increment on each poller call
        return this.instrumentGrpService.getSecurityGroupbyID(
          this.reviewInstGroupData.id,
          this.reviewInstGroupData.businessUnit.value,
          ''
        );
      }),
      takeWhile(
        (response: any) => {
           // Initialize a flag to check if the reqCorrelationId matches
          let reqCorrelationIdMatches = true;
           // If the reqCorrelationId in the response does not match the expected reqCorrelationId, set the flag to false
          if (response?.data?.ngOMSSecurityGroupsInfo?.reqCorrelationId !== reqCorrelationId) {
            reqCorrelationIdMatches = false;
          }
          // Continue polling if:
          // 1. The lastSyncStatus is NOT success, failed, or notEligible
          // 2. OR the reqCorrelationId matches the expected reqCorrelationId
          return (
            (response?.data?.ngOMSSecurityGroupsInfo?.lastSyncStatus?.toUpperCase() !== this.getSharedConstant.ngOMS.success
              && response?.data?.ngOMSSecurityGroupsInfo?.lastSyncStatus?.toUpperCase() !== this.getSharedConstant.ngOMS.failed
              && response?.data?.ngOMSSecurityGroupsInfo?.lastSyncStatus?.toUpperCase() !== this.getSharedConstant.ngOMS.notEligible)
            || reqCorrelationIdMatches
          );
        },
        true // Ensure the value that causes the condition to fail is also emitted
      ),
      take(5)
    ).subscribe((response: any) => {
      if (!response?.data?.ngOMSSecurityGroupsInfo && !this.instrumentGrpService.deletedIG) {
        this.showIGAssignPanel = true;
        this.ngOMSForceSync = true;
        this.downLoadNGOMSIG = false;
        return;
      } else if (!response?.data?.ngOMSSecurityGroupsInfo && this.instrumentGrpService.deletedIG) {
        this.showIGAssignPanel = this.ngOMSForceSync = this.downLoadNGOMSIG = false;
        return;
      }
      this.formDataService.setFormData(response?.data);
      this.reviewInstGroupData = this.formDataService.getFormData();
      const status = response?.data?.ngOMSSecurityGroupsInfo?.lastSyncStatus.toUpperCase();
      if ((status === this.getSharedConstant.ngOMS.success || status === this.getSharedConstant.ngOMS.failed ||
        status === this.getSharedConstant.ngOMS.notEligible) && response?.data?.ngOMSSecurityGroupsInfo?.reqCorrelationId !== reqCorrelationId) {
        this.forceSyncStatusSubscription.unsubscribe();
        this.ngomsEnablingOfButtonsAfterPolling();
      } else if (pollerCallCount === 5) {
        this.ngomsEnablingOfButtonsAfterPolling();
      }
      this.ruleService.toastMsg.emit('');
      this.ruleService.toastType.emit('');
    });
    return this.forceSyncStatusSubscription;
  }

  validateForceSyncDownloadBtns() {
    this.disableDownloadButton = this.reviewInstGroupData.ngOMSSecurityGroupsInfo?.groupId ? false : true;
    this.forceSyncDisableBtn =  false;
  }

  canDeactivate(event, observer) {
    this.showActionItems = this.sharedService.checkEntitlements(this.entitlementConst.navUUID.emtrAccess.manageInstruments.uuid, '', '') && !this.instrumentGrpService.deletedIG;
    this.confirmMessage.message = (this.confirmMessage.message !== undefined && this.confirmMessage.message) ? this.confirmMessage.message : this.getConstant.rulesConstant.confirmationMessage.menuClickMsg;
    if (this.cancelButton && this.showActionItems && !this.revertDisable) {
      this.localObserver = observer;
      return this.confirmationMessage.showConfirmMsg(this.confirmMessage, observer);
    }
    return true;
  }

  onChanges(): void {
    this.reviewInstrumentGrpForm.controls.groupName.valueChanges.subscribe(groupNameValue => {
      this.groupNameExists = false;
      const regExp = new RegExp('^[a-zA-Z0-9+_()\[\\],.\\- ]*$');
      if (groupNameValue && !regExp.test(groupNameValue)) {
        if (this.errorMsg.indexOf(this.getSharedConstant.textFieldErrorMsg.invalidCharacterForGrpOrRuleName) === -1) {
          this.errorMsg.push(this.getSharedConstant.textFieldErrorMsg.invalidCharacterForGrpOrRuleName);
        }
        this.ruleService.showSchError.emit(true);
      } else {
        this.errorMsg.splice(this.errorMsg.indexOf(this.getSharedConstant.textFieldErrorMsg.invalidCharacterForGrpOrRuleName), 1);
      }

      /*To remove group name already exist error msg from the errorMsg array*/
      if (this.errorMsg.indexOf(this.instGroupNameExistsErrMsg) !== -1) {
        this.errorMsg.splice(this.errorMsg.indexOf(this.instGroupNameExistsErrMsg), 1);
      }

      /*Hide the error block when errorMsg is empty*/
      if (this.errorMsg.length === 0) {
        this.ruleService.showSchError.emit(false);
      }

      this.ruleService.schErrorMsg.emit(this.errorMsg);
    });


    /*  Select Securities filter value changes  */
    this.filterReviewInstrumentGrpForm.get('tickerSymbol').valueChanges.subscribe(value => {
      this.invalidTickerSymbol = (value && this.filterReviewInstrumentGrpForm.get('tickerSymbol').invalid)
      this.instrumentGrpService.invalidTickerSymbolField.emit(this.invalidTickerSymbol);
    });

    this.filterReviewInstrumentGrpForm.get('name').valueChanges.subscribe(value => {
      this.invalidName = (value && value.length < 2);
      this.instrumentGrpService.invalidNameField.emit(this.invalidName);
    });

    this.filterReviewInstrumentGrpForm.get('cusip').valueChanges.subscribe(value => {
      this.invalidCusip= this.sharedService.isValueLengthLessThan9(value);
      if(this.invalidCusip){
      this.instrumentGrpService.invalidCusipSymbolFieldIG.emit(true);
      }
      else {
        this.instrumentGrpService.invalidCusipSymbolFieldIG.emit(false);
      }
      if (this.filterReviewInstrumentGrpForm.get('cusip').invalid) {
        this.instrumentGrpService.specialCharValidationForCusip.emit(true);
      } else {
        this.instrumentGrpService.specialCharValidationForCusip.emit(false);
      }
    });

    this.filterReviewInstrumentGrpForm.controls.sedol.valueChanges.subscribe(value => {
      this.invalidSedol = (value && value.length < 7)
      this.instrumentGrpService.invalidSedolField.emit(this.invalidSedol);
      if (this.filterReviewInstrumentGrpForm.get('sedol').invalid) {
        this.instrumentGrpService.specialCharValidationForSedol.emit(true);
      } else {
        this.instrumentGrpService.specialCharValidationForSedol.emit(false);
      }
    });

    this.filterReviewInstrumentGrpForm.controls.isin.valueChanges.subscribe(value => {
      this.invalidIsin = (value && value.length < 12)
      this.instrumentGrpService.invaliIsinField.emit(this.invalidIsin);
      if (this.filterReviewInstrumentGrpForm.get('isin').invalid) {
        this.instrumentGrpService.specialCharValidationForIsin.emit(true);
      } else {
        this.instrumentGrpService.specialCharValidationForIsin.emit(false);
      }
    });
  }

  checkWhetherInstGroupNameExists(ruleObj) {
    const formData = this.formDataService.getFormData();
    if (this.reviewInstGroupData.mode === 'EDIT' && this.reviewInstrumentGrpForm.get('groupName').value.trim() === formData.currentEditedName.trim()) {
      this.saveInstGroupData(ruleObj);
    } else {
      const type = this.sharedService.groupType === this.getSharedConstant.manageMasterGroups.groupTypeMGP ? this.sharedService.groupType : '';
      const planIdValue = '';
      this.instrumentGrpService.checkWhetherInstGrpExists(ruleObj.name, ruleObj.businessUnit).subscribe(res => {
        this.sharedService.decodeUrl = true;
        if (res && res.data !== null) {
          /* eslint-disable-next-line max-len */
          this.instGroupNameExistsErrMsg = this.getConstant.rulesConstant.ruleNameMsg.the + '<strong>' + ' " ' + this.reviewInstrumentGrpForm.get('groupName').value.trim() + '"' + '</strong>' + this.getConstant.instrumentGroups.instrumentGrpStep1.groupNameExists;
          this.groupNameExists = true;
          this.cancelButton = false;

          /*To show group name already exist error msg*/
          if (this.errorMsg.indexOf(this.instGroupNameExistsErrMsg) === -1) {
            this.errorMsg.push(this.instGroupNameExistsErrMsg);
          }
          this.ruleService.schErrorMsg.emit(this.errorMsg);
          this.ruleService.showSchError.emit(true);

        } else {
          this.saveInstGroupData(ruleObj);
        }
      });
    }
  }
  toggleFunction() {
    this.toggle = !this.toggle;
  }

  clickedClearButton(resetSortFromUI?) {
    this.resetForm(resetSortFromUI);
    this.sharedService.tableDropdownVal.next(this.pageObject.pageSize);
    if (!this.sortClearButtonReset) {
      this.getFilterInstrumentGroupList();
    }
  }

  onInputChange(fieldName: string, event: any) {
    const value = event.target.value;
    const fieldListExceptActions = Object.keys(this.filterReviewInstrumentGrpForm.controls).filter(field => field !== 'actions');
    const updatedFields = fieldListExceptActions.filter(field => field !== fieldName);
    if (value && value.trim().length > 0) {
      updatedFields.forEach(field => {
        if(field !== 'securityType'){
           this.filterReviewInstrumentGrpForm.get(field).reset();
        }else {
          this.filterReviewInstrumentGrpForm.patchValue({securityType: this.getEmtrConstants.instrumentGroups.instrumentGrpStep3.securityTypeList});
        }
        this.filterReviewInstrumentGrpForm.get(field).disable();
      });
    } else {
      fieldListExceptActions.forEach(field => {
        this.filterReviewInstrumentGrpForm.get(field).enable();
      });
    }
  }
  resetForm(resetSortFromUI?) {
    this.filterClicked = false;
    const fieldListExceptActions = Object.keys(this.filterReviewInstrumentGrpForm.controls).filter(field => field !== 'actions');
    fieldListExceptActions.forEach(field => {
      this.filterReviewInstrumentGrpForm.get(field).enable();
      if(field !== 'securityType'){
           this.filterReviewInstrumentGrpForm.get(field).reset();
        }else {
          this.filterReviewInstrumentGrpForm.patchValue({securityType: this.getEmtrConstants.instrumentGroups.instrumentGrpStep3.securityTypeList});
        }
    });

    this.filterReviewInstrumentGrpForm.markAsPristine();
    if (resetSortFromUI) {
      this.multiSortMeta = [this.defaultSortDataField];
      this.sortClearButtonReset = true;
    }
    if (this.toggle) {
      this.isClickedClearBtn = true;
    }
    this.pageObject.pageNo = 0;
    if (this.paginator) {
      this.paginator.changePage(0);
    }
    this.filterReviewInstrumentGrpForm.patchValue({securityType: this.getEmtrConstants.instrumentGroups.instrumentGrpStep3.securityTypeList});
    this.filterClicked = this.isClickedClearBtn = this.filtersApply = false;
    this.filterReviewInstrumentGrpForm.markAsPristine();
  }
  applyFilter() {
    this.filterClicked = this.paginationCount > 1 ? true : false;
    this.filtersApply = true;
    this.pageObject.pageNo = 0;
    if (this.paginator) {
      this.paginator.changePage(0);
    }
    this.getFilterInstrumentGroupList();
    this.selectedSecurities = [...this.selectedSecurities];
  }
  getFilterInstrumentGroupList() {
    const filterValues: any = {
      parentId: this.reviewInstGroupData.id,
      securityTypeList: ['All']
    };
    const formValues = this.filterReviewInstrumentGrpForm.value;
    Object.keys(formValues).forEach(key => {
      const value = formValues[key];
      if (
        value !== null &&
        value !== '' &&
        !(Array.isArray(value) && value.length === 0)
      ) {
        if (key === 'securityType') {
          filterValues['securityTypeList'] = value?.length ===this.getEmtrConstants.instrumentGroups.instrumentGrpStep3.securityTypeList.length ? ['All'] 
          : value.map(item => item.value);
        } else {
          filterValues[key] = value;
        }
      }
    });
    this.instrumentGrpService.filterIgSecurities(this.pageObject, filterValues).subscribe({
      next: (response: any) => {
        if (response?.data) {
          this.selectedSecurities = response.data.content;
          this.totalSecurities = this.sharedService.totalElementsWithCommas(response.data.totalElements);
          this.paginationCount = response.data.totalElements;
          this.filterClicked = this.paginationCount > 1 ? true : false;
          if (this.selectedSecurities.length > 0) {
            return this.selectedSecurities;
          }
        }
        else {
          this.selectedSecurities = [];
          this.totalSecurities = this.sharedService.totalElementsWithCommas(0);
          return this.selectedSecurities;
        }
      }, error: error => {
        this.selectedSecurities = [];
        this.totalSecurities = 0;
        return this.selectedSecurities;
      }
    });
  }
  customSort(event) {
    if (event.multiSortMeta) {
      this.multiSortMetaDup = this.multiSortMeta;
      this.multiSortMeta = event.multiSortMeta;
      const sortArr = this.customSortService.customSort(event);
        if (this.pageObject.sortField !== sortArr) {
        this.isSortingChanged = (JSON.stringify(event.multiSortMeta) === JSON.stringify([this.defaultSortDataField])) ? false : true;
          this.pageObject.pageNo = 0;
          if (this.paginator) {
            this.paginator.changePage(0);
          }
          if ((this.multiSortMetaDup !== this.multiSortMeta) || this.multiSortMetaDup.length > 1 || this.sortClearButtonReset) {
          this.pageObject = {
          pageNo: this.pageObject.pageNo,
          pageSize: this.pageObject.pageSize,
          sortField: sortArr
        };
            this.getFilterInstrumentGroupList();
            this.sortClearButtonReset = false;
          }
       }
      }
  }

  paginate(e) {
    if (this.pageObject.pageNo !== e.page) {
      this.pageObject.pageNo = e.page;
      this.getFilterInstrumentGroupList();
    }
  }

   ngOnDestroy() {
    if (this.forceSyncStatusSubscription && typeof this.forceSyncStatusSubscription.unsubscribe === 'function') {
      this.forceSyncStatusSubscription.unsubscribe();
    }
     this.instrumentGrpService.invalidTickerSymbolField.emit(false);
     this.instrumentGrpService.invalidNameField.emit(false);
     this.instrumentGrpService.invalidCusipSymbolFieldIG.emit(false);
     this.instrumentGrpService.invalidSedolField.emit(false);
     this.instrumentGrpService.invaliIsinField.emit(false);
     this.instrumentGrpService.specialCharValidationForCusip.emit(false);
     this.instrumentGrpService.specialCharValidationForSedol.emit(false);
     this.instrumentGrpService.specialCharValidationForIsin.emit(false);
  }
}
